import type { BoundBaggageInfoType } from '../baggages/models';

export const hasDifferencesBetweenBoundsForPassenger = (
  passengerId: string,
  transformedBaggagePerBound: BoundBaggageInfoType[],
) =>
  transformedBaggagePerBound.some((boundBaggage) => {
    const travelerBaggageInfo = boundBaggage.baggageInfoPerTraveler.find(
      (el) => el.id === passengerId,
    );

    if (travelerBaggageInfo) {
      return (
        travelerBaggageInfo.cabinBaggage?.hasChangesInPieces ||
        travelerBaggageInfo.cabinBaggage?.hasChangesInWeight ||
        travelerBaggageInfo.checkedBaggage?.hasChangesInPieces ||
        travelerBaggageInfo.checkedBaggage?.hasChangesInWeight ||
        travelerBaggageInfo.personalItem?.hasChangesInPieces ||
        travelerBaggageInfo.secondBaggage?.hasChangesInPieces ||
        travelerBaggageInfo.secondBaggage?.hasChangesInWeight
      );
    }
    return false;
  });
